<template>
  <v-container fluid class="admin-operator">
    <v-row class="flex-grow-0">
      <v-col>
        <label class="text-h5">{{ $t('admin_operator.title') }}</label>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               @click="addOperatorModalShown = true">
          {{ $t('admin_operator.add_operator') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col class="pa-0">
        <OperatorList full-height
                      :refresh-trigger.sync="refreshTrigger"
                      @edit="onOperatorEdit"></OperatorList>
      </v-col>
    </v-row>

    <AddOperatorModal :shown="addOperatorModalShown"
                      @cancel="addOperatorModalShown = false"
                      @finish="onAddOperatorModalFinish"></AddOperatorModal>

    <EditOperatorModal :shown="editOperatorModalShown"
                       :operator-id="editingOperatorId"
                       @cancel="editOperatorModalShown = false"
                       @finish="onEditOperatorModalFinish"></EditOperatorModal>
  </v-container>
</template>

<script>
import OperatorList from "@/components/operator/OperatorList";
import {ref} from "@vue/composition-api";
import AddOperatorModal from "@/components/operator/AddOperatorModal";
import EditOperatorModal from "@/components/operator/EditOperatorModal";

export default {
  name: 'Operator',
  components: {EditOperatorModal, AddOperatorModal, OperatorList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const addOperatorModalShown = ref(false);
    const onAddOperatorModalFinish = function (item) {
      addOperatorModalShown.value = false;
      refresh();
      onOperatorEdit(item);
    }

    const editingOperatorId = ref(null);
    const editOperatorModalShown = ref(false);
    const onOperatorEdit = function (item) {
      editingOperatorId.value = item.account.id;
      editOperatorModalShown.value = true;
    };
    const onEditOperatorModalFinish = function () {
      editOperatorModalShown.value = false;
      refresh();
    }

    return {
      refreshTrigger,
      refresh,

      addOperatorModalShown,
      onAddOperatorModalFinish,

      editingOperatorId,
      editOperatorModalShown,
      onOperatorEdit,
      onEditOperatorModalFinish,
    }
  },
}
</script>

<style lang="less">
.admin-operator {
  height: calc(100% - 110px);
  display: flex;
  flex-direction: column;

  .admin-operator-main {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>
